import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CondicaoDePagamento } from 'src/app/models/condicao-de-pagamento';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CondicaoDePagamentoService } from 'src/app/services/condicao-de-pagamento.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { MaskedNumber } from "imask";

@Component({
  selector: 'app-cadastrar-condicao-de-pagamento',
  templateUrl: './cadastrar-condicao-de-pagamento.component.html',
  styleUrls: ['./cadastrar-condicao-de-pagamento.component.scss']
})
export class CadastrarCondicaoDePagamentoComponent implements OnInit {

  // variáveis
  idCondicaoDePagamento;
  condicaoPagamentoPadrao: CondicaoDePagamento = {
    idCondPag: 0,
    descricao: '',
    nParcelas: 1,
    entrada: false,
    diasParcelas: 0,
    codErp: null,
    taxaDA: 0,
    status: 1,
    valorMinimo: 0,
    valorMaximo: 0
  }
  condicaoPagamentoFormControl: FormGroup;
  condicaoPagamentoFormData: FormGroup;
  editando = false;
  statusCadastroModel = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];

  public readonly MaskedNumber = MaskedNumber;

  constructor(private route: ActivatedRoute,
              private notificacaoService: NotificacaoService,
              private condicaoDePagamentoService: CondicaoDePagamentoService,
              private router: Router,
              private carregandoService: CarregandoService) {
    // Usando Angular Reactive Form para facilitar na validação dinâmica dos campos
    this.createReactiveForm();
  }

  ngOnInit() {
    // se for edição, busca o condicaoDePagamento do id passado
    if (this.route.snapshot.paramMap.get('id')) {
      this.idCondicaoDePagamento = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarCondicaoDePagamento();
    } else {
      // Se for 'novo' resetar o form com os valores padrão.
      this.condicaoPagamentoFormControl.reset();
      this.condicaoPagamentoFormData.reset(this.condicaoPagamentoPadrao);
    }
  }

  createReactiveForm() {
    // Este form é usado somente para controle dos campos. Fiz isso para separar os campos de controle dos dados que
    // serão enviados para a API.
    this.condicaoPagamentoFormControl = new FormGroup({
      habilitaValorMinimo: new FormControl(false),
      habilitaValorMaximo: new FormControl(false),
    });

    // Este form será enviado para a API.
    this.condicaoPagamentoFormData = new FormGroup({
      idCondPag: new FormControl(this.condicaoPagamentoPadrao.idCondPag),
      descricao: new FormControl(this.condicaoPagamentoPadrao.descricao, Validators.required),
      nParcelas: new FormControl(this.condicaoPagamentoPadrao.nParcelas, [Validators.required, Validators.min(1)]),
      entrada: new FormControl(this.condicaoPagamentoPadrao.entrada),
      diasParcelas: new FormControl(this.condicaoPagamentoPadrao.diasParcelas, [Validators.required, Validators.min(0)]),
      codErp: new FormControl(this.condicaoPagamentoPadrao.codErp),
      taxaDA: new FormControl(this.condicaoPagamentoPadrao.taxaDA, [Validators.required, Validators.pattern("^[-+]?([0-9]+|\\.[0-9]+|[0-9]+\\.[0-9]+)$")]),
      status: new FormControl(this.condicaoPagamentoPadrao.status, Validators.required),
      valorMinimo: new FormControl(this.condicaoPagamentoPadrao.valorMinimo),
      valorMaximo: new FormControl(this.condicaoPagamentoPadrao.valorMaximo),
    }, {
      validators: this.validarCondicaoPagamentoFormData()
    });

    // Aqui eu observo os campos individualmente e crio regras com base em seus valores.
    this.condicaoPagamentoFormData.get("nParcelas").valueChanges.subscribe((value) => {
      const control = this.condicaoPagamentoFormData.get("entrada");

      if (Number.isSafeInteger(Number(value)) && Number(value) > 1) {
        control.enable();
      } else {
        control.setValue(false, {onlySelf: true});
        control.disable();
      }
    });

    this.condicaoPagamentoFormControl.get("habilitaValorMinimo").valueChanges.subscribe((value) => {
      const control = this.condicaoPagamentoFormData.get("valorMinimo");

      if (Boolean(value)) {
        control.setValidators([Validators.required, Validators.min(1)])
        control.enable();
      } else {
        control.clearValidators();
        control.setValue("0", {onlySelf: true});
        control.disable();
      }
    });

    this.condicaoPagamentoFormControl.get("habilitaValorMaximo").valueChanges.subscribe((value) => {
      const control = this.condicaoPagamentoFormData.get("valorMaximo");

      if (Boolean(value)) {
        control.setValidators([Validators.required, Validators.min(1)]);
        control.enable();
      } else {
        control.clearValidators();
        control.setValue("0", {onlySelf: true});
        control.disable();
      }
    });
  }

  validarCondicaoPagamentoFormData(): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      const valorMinimoControl = control.get("valorMinimo");
      const valorMaximoControl = control.get("valorMaximo");

      if (Number(valorMinimoControl.value) > 0 && Number(valorMaximoControl.value) > 0) {
        if (Number(valorMinimoControl.value) >= Number(valorMaximoControl.value)) {
          return { "invalidMinMax": true };
        }
      }

      return null;
    };
  }

  buscarCondicaoDePagamento() {
    this.carregandoService.mostra('buscarCondicaoDePagamento');

    this.condicaoDePagamentoService.consultarPorId(this.idCondicaoDePagamento).subscribe((condicao) => {
      this.condicaoPagamentoFormControl.setValue({
        habilitaValorMinimo: condicao.valorMinimo > 0,
        habilitaValorMaximo: condicao.valorMaximo > 0
      });
      //this.condicaoPagamentoFormData.setValue(condicao);

      // O Angular8 e o IMask compatível com ele não suporta valores em outros formatos a não ser string :(
      this.condicaoPagamentoFormData.setValue({
        ...condicao,
        nParcelas: condicao.nParcelas.toString(),
        diasParcelas: condicao.diasParcelas.toString(),
        taxaDA: condicao.taxaDA.toString(),
        valorMinimo: condicao.valorMinimo.toString(),
        valorMaximo: condicao.valorMaximo.toString(),
      });

      this.carregandoService.esconde('buscarCondicaoDePagamento');
    }, (erro) => {
      this.carregandoService.esconde('buscarCondicaoDePagamento');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaCondicaoDePagamento');
    // Existem 2 métodos para pegar os valores do Form: value() e getRawValue()
    // Por enquanto a API não suporta update parcial então vou utilizar o getRawValue() que retorna todos os campos.
    const condicaoDePagamento = this.condicaoPagamentoFormData.getRawValue();

    this.condicaoDePagamentoService.salvar(condicaoDePagamento).subscribe(() => {
      this.notificacaoService.sucesso('CondicaoDePagamento salvo com sucesso!!!');
      this.router.navigate(['configuracoes/condicoes-de-pagamento']).then(() => {
        this.carregandoService.esconde('salvaCondicaoDePagamento');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaCondicaoDePagamento');
      this.notificacaoService.erro(erro);
    });
  }
}
